import React from "react";

export const CloseButton = ({ style = {}, onClick = () => { } }) => {
  return (
    <div onClick={onClick} style={{ position: "absolute", top: "10px", right: "20px", cursor: "pointer", zIndex: 20000, ...style }}><i className="fa fa-times" /></div>
  )
}

export default CloseButton;
